import React from 'react';
import { ArcButton, ArcDialog, ArcOutlinedInput, ArcStack, ArcText } from '@src/core/ui';
import { InputAdornment } from '@mui/material';
import type { AdjustPopupProps } from '../types';

const AdjustPopup: React.FC<AdjustPopupProps> = ({ type, initialValue, open, onClose, onSave }) => {
  const label = type === 'runtime' ? 'Adjust Runtime' : 'Adjust Service Limit';

  const [draft, setDraft] = React.useState(() => (Number.isFinite(initialValue) ? String(initialValue) : ''));

  React.useEffect(() => {
    if (!open) return;
    setDraft(Number.isFinite(initialValue) ? String(initialValue) : '');
  }, [open, initialValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(',', '.');
    if (raw !== '' && !/^\d*\.?\d*$/.test(raw)) return;
    setDraft(raw);
  };

  const commitSave = () => {
    const trimmed = draft.replace(',', '.').trim();
    if (trimmed === '' || trimmed === '.' || trimmed === '-') {
      onSave(0);
      return;
    }
    const num = parseFloat(trimmed);
    const safe = Number.isNaN(num) ? 0 : num;
    onSave(safe);
  };

  return (
    <ArcDialog
      open={open}
      onClose={onClose}
      title={label}
      contextSX={{ px: 4, paddingBottom: 3 }}
    >
      <ArcStack spacing={2}>
        <ArcOutlinedInput
          autoComplete="off"
          label={label}
          value={draft}
          onChange={handleChange}
          inputProps={{ inputMode: 'decimal' }}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <ArcText.h5>h</ArcText.h5>
                </InputAdornment>
              ),
            },
          }}
        />
        <ArcButton.brand onClick={commitSave}>
          Save
        </ArcButton.brand>
      </ArcStack>
    </ArcDialog>
  );
};

export default AdjustPopup;
